import React from 'react';

import BaseToast from 'components/shared/toasts/BaseToast';

interface SuccessToastProps {
  message: string | null;
}

const SuccessToast: React.FC<SuccessToastProps> = ({ message }) => {
  return (
    <BaseToast
      message={message}
      colorScheme={{
        text: '#00A18F',
        background: '#D1FAE5',
        border: '#D1FAE5',
      }}
    />
  );
};

export default SuccessToast;
